import AppDialog from '../../components/app_dialog'
import { TextField, Select } from '@cinesend/ui-kit'
import { useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

const CreateOrgModal = ({ onClose }) => {
  const [name, setName] = useState('')
  const [userID, setUserID] = useState(null)
  const { createModel } = useStore()
  const { data: { data: users } = { data: [] } } = useQuery(['users'])
  const navigate = useNavigate()

  const create = () => {
    createModel.mutate(
      {
        endpoint: 'organizations',
        data: {
          name,
          owner_id: userID,
        },
      },
      {
        onSuccess: (res) => {
          navigate(`/settings/organizations/${res.data.organization.id}`)
        },
      }
    )
  }
  return (
    <AppDialog
      title='Create organization'
      onClose={onClose}
      confirmText='Create'
      onConfirm={() => create()}
      confirmDisabled={name.length === 0 || !userID}
    >
      <div className='space-y-2'>
        <TextField value={name} label='Name' onChange={(e) => setName(e.target.value)} />
        <Select
          fullWidth
          label='Organization Owner'
          value={userID ? String(userID) : null}
          options={users?.map((opt) => ({ value: String(opt.id), label: opt.name })) ?? []}
          onValueChange={(id) => setUserID(Number(id))}
        />
      </div>
    </AppDialog>
  )
}

export default CreateOrgModal
